var labels = {
  requests_title: {
    es: 'Solicitudes',
    en: 'Requests'
  },
  subtitle_requests: {
    es: 'Informe de solicitudes generadas por su usuario. Se podrá visualizar el detalle de la solcitud y el estado en que se encuentra.',
    en: 'Report of requests generated by your user. You will be able to view the details of the request and its status.'
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  tablas: {
    nivel: 2,
    object: {
      es: 'Objeto',
      en: 'Object'
    },
    operator: {
      es: 'Operador',
      en: 'Operator'
    },
    type: {
      es: 'Tipo',
      en: 'Type'
    },
    creation_date: {
      es: 'Fecha de creación',
      en: 'Creation date'
    },
    status: {
      es: 'Estado',
      en: 'Status'
    },
    response_date: {
      es: 'Fecha de respuesta',
      en: 'Response date'
    },
    end_date: {
      es: 'Fecha fin',
      en: 'End date'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    },
    supervisor: {
      es: 'Supervisor',
      en: 'Supervisor'
    },
    source: {
      es: 'Fuente',
      en: 'Source'
    },
    responsible: {
      es: 'Responsable',
      en: 'Responsible'
    },
    applicant: {
      es: 'Solicitante',
      en: 'Applicant'
    }
  },
  search_from: {
    es: 'Desde',
    en: 'From'
  },
  search_to: {
    es: 'Hasta',
    en: 'To'
  },
  type: {
    es: 'Tipo',
    en: 'Type'
  },
  status: {
    es: 'Estado',
    en: 'Status'
  },
  organization: {
    es: 'Organización',
    en: 'Organization'
  },
  applicant: {
    es: 'Solicitante',
    en: 'Applicant'
  },
  details: {
    es: 'Detalles',
    en: 'Details'
  },
  cancel_request: {
    es: 'Cancelar',
    en: 'Cancel'
  },
  view_request: {
    es: 'Ver solicitud',
    en: 'View request'
  },
  view_change_metadata: {
    es: 'Ver cambio de metadata',
    en: 'View change_metadata'
  }
};
export default labels;